// extracted by mini-css-extract-plugin
export var sectionContainer = "e_L_9";
export var svgFillColor = "#e9f3ff";